import { render, staticRenderFns } from "./inscricao.vue?vue&type=template&id=106f1e27&"
import script from "./inscricao.vue?vue&type=script&lang=js&"
export * from "./inscricao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports